
import { Component, Vue } from 'vue-property-decorator'
import { NavBar } from '@/components'

@Component({
  components: {
    NavBar
  }
})
export default class AppContent extends Vue {
  data () {
    return {
    }
  }

  get isLoggedIn () {
    return this.$store.state.loggedIn
  }
}
